window.handleCartOptionEvents = function() {
	document.body.addEventListener('click', function(event) {
		// Apply discount button
		if (event.target.id === 'apply-discount-btn' || event.target.closest('#apply-discount-btn')) {
			const inputVal = document.getElementById('discount-code-input').value;
			const errorElement = document.querySelector('.discount-code-error');
			const applyButton = document.getElementById('apply-discount-btn');
			
			errorElement.innerHTML = '';
			
			if (!inputVal || inputVal === 'undefined') {
				errorElement.innerHTML = 'Please enter discount code!';
			} else {
				applyButton.innerHTML = "APPLYING <div class='loader'></div>";
				
				fetch(`/discount/${inputVal}`)
					.then(() => fetch('/cart'))
					.then(response => response.text())
					.then(() => fetch('/cart.js'))
					.then(res => res.json())
					.then(data => {
						if (data.total_discount > 0) {
							applyButton.innerHTML = 'APPLIED';
							document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
							document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
						} else {
							applyButton.innerHTML = 'APPLY';
							errorElement.innerHTML = "DISCOUNT CODE ISN'T VALID FOR THE ITEMS IN YOUR CART";
						}
					});
			}
		}
		
		// Clear discount button
		if (event.target.id === 'clear-discount-btn') {
			const deleteVal = 'DELETE_COUPON';
			const errorElement = document.querySelector('.discount-code-error');
			const applyButton = document.getElementById('apply-discount-btn');
			
			errorElement.innerHTML = '';
			applyButton.innerHTML = "REMOVING <div class='loader'></div>";
			
			fetch(`/discount/${deleteVal}`)
				.then(() => fetch('/cart'))
				.then(response => response.text())
				.then(() => fetch('/cart.js'))
				.then(res => res.json())
				.then(data => {
					applyButton.innerHTML = 'DELETED';
					document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
					document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
				});
		}
		
		// Coupon code button
		if (event.target.classList.contains('couponCodeButton') || event.target.closest('.couponCodeButton')) {
			const button = event.target.classList.contains('couponCodeButton') ? 
										event.target : 
										event.target.closest('.couponCodeButton');
			const inputVal = button.dataset.coupon_code;
			const errorElement = document.querySelector('.discount-code-error');
			
			button.innerHTML = "<div class='loader'></div>";
			
			fetch(`/discount/${inputVal}`)
				.then(() => fetch('/cart'))
				.then(response => response.text())
				.then(() => fetch('/cart.js'))
				.then(res => res.json())
				.then(data => {
					if (data.total_discount > 0) {
						button.innerHTML = 'APPLIED';
						document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
						document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
					} else {
						const couponButtons = document.querySelectorAll('.couponCodeButton');
						couponButtons.forEach(btn => {
							btn.innerHTML = 'APPLY';
						});
						errorElement.innerHTML = "Discount code isn't valid for the items in your cart";
					}
				});
		}
	});
};

document.addEventListener('DOMContentLoaded', function() {
	window.handleCartOptionEvents();
});